import { FlexRow, FlexSpacer, Text } from '@epam/loveship'

import { RatingReadOnly } from '../../../../../../components/RatingReadOnly/RatingReadOnly'
import css from './ReviewSummary.module.scss'

type ReviewSummaryProps = {
  itemRating: number
}

export const ReviewSummary = ({ itemRating }: ReviewSummaryProps) => {
  return (
    <FlexRow>
      <RatingReadOnly value={itemRating} />
      <FlexSpacer />
      <Text size="48" cx={css.text}>
        {itemRating}
      </Text>
    </FlexRow>
  )
}
